module.exports = __webpack_public_path__ + "img/inbox.ea1e4822.svg";